import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import 'bootstrap/dist/css/bootstrap.min.css';

function ContactUs() {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        subject: '',
        message: '',
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // WhatsApp Number
        const whatsappNumber = "94775340670";

        const message = t('contactUs.form.whatsappMessage', {
            name: formData.name,
            phone: formData.phone,
            email: formData.email,
            subject: formData.subject,
            message: formData.message,
        });

        const whatsappURL = `https://wa.me/${whatsappNumber}?${new URLSearchParams({ text: message })}`;

        // Open WhatsApp
        window.open(whatsappURL, '_blank');

        // Reset Form
        setFormData({
            name: '',
            phone: '',
            email: '',
            subject: '',
            message: '',
        });
    };

    return (
        <div className="container font:times">
            {/* Intro Section - Desktop (md and larger) */}
            <div className="text-center my-6 sm:my-8 md:my-10 hidden md:block font:times">
                <h5 className="text-[#E6A71A] text-base sm:text-lg md:text-xl mb-2 sm:mb-3">
                    {t('contactUs.introSection.subtitle')}
                </h5>
                <h1 className="text-[#114131] text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-6 md:mb-8">
                    {t('contactUs.introSection.title')}
                </h1>
                <p className="text-gray-600 text-base sm:text-lg md:text-xl mx-auto mb-4 md:mb-6 max-w-[1200px]">
                    {t('contactUs.introSection.description1')}
                </p>
                <p className="text-gray-600 text-base sm:text-lg md:text-xl mx-auto max-w-[1200px]">
                    {t('contactUs.introSection.description2')}
                </p>
            </div>

            {/* Intro Section - Mobile (sm) */}
            <div className="text-center my-6 sm:my-8 block md:hidden">
                <h5 className="text-[#E6A71A] text-sm sm:text-base mb-2 sm:mb-3">
                    {t('contactUs.introSection.subtitle')}
                </h5>
                <h1 className="text-[#114131] text-2xl sm:text-3xl font-bold mb-4 sm:mb-6">
                    {t('contactUs.introSection.title')}
                </h1>
                <p className="text-gray-600 text-base sm:text-lg mx-auto mb-4 sm:mb-6 max-w-[90%]">
                    {t('contactUs.introSection.description1')}
                </p>
                <p className="text-gray-600 text-base sm:text-lg mx-auto max-w-[90%]">
                    {t('contactUs.introSection.description2')}
                </p>
            </div>

            {/* Form Section - Desktop (md and larger) */}
            <div className="text-center my-6 sm:my-8 md:my-10 hidden md:block">
                <h5 className="text-[#E6A71A] text-base sm:text-lg md:text-xl mb-2 sm:mb-3">
                    {t('contactUs.formSection.subtitle')}
                </h5>
                <h1 className="text-[#114131] text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-6 md:mb-8">
                    {t('contactUs.formSection.title')}
                </h1>
                <div className="row">
                    <div className="col-md-6 mx-auto w-full max-w-[800px]">
                        <form onSubmit={handleSubmit} className="p-4 sm:p-6">
                            <div className="mb-3 sm:mb-4">
                                <input
                                    type="text"
                                    className="w-full p-2 sm:p-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#114131]"
                                    name="name"
                                    placeholder={t('contactUs.form.namePlaceholder')}
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="mb-3 sm:mb-4">
                                <input
                                    type="tel"
                                    className="w-full p-2 sm:p-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#114131]"
                                    name="phone"
                                    placeholder={t('contactUs.form.phonePlaceholder')}
                                    value={formData.phone}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="mb-3 sm:mb-4">
                                <input
                                    type="email"
                                    className="w-full p-2 sm:p-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#114131]"
                                    name="email"
                                    placeholder={t('contactUs.form.emailPlaceholder')}
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="mb-3 sm:mb-4">
                                <input
                                    type="text"
                                    className="w-full p-2 sm:p-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#114131]"
                                    name="subject"
                                    placeholder={t('contactUs.form.subjectPlaceholder')}
                                    value={formData.subject}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="mb-3 sm:mb-4">
                                <textarea
                                    className="w-full p-2 sm:p-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#114131]"
                                    name="message"
                                    placeholder={t('contactUs.form.messagePlaceholder')}
                                    value={formData.message}
                                    onChange={handleChange}
                                    rows="4"
                                    required
                                ></textarea>
                            </div>
                            <div className="mb-3 sm:mb-4 flex items-center justify-center">
                                <input
                                    type="checkbox"
                                    className="h-4 w-4 sm:h-5 sm:w-5 text-[#114131] border-gray-300 rounded focus:ring-[#114131]"
                                    id="terms"
                                    required
                                />
                                <label
                                    className="ml-2 text-gray-600 text-sm sm:text-base"
                                    htmlFor="terms"
                                >
                                    {t('contactUs.form.termsLabel')}
                                </label>
                            </div>
                            <button
                                type="submit"
                                className="w-full bg-[#114131] hover:bg-[#E6A71A] text-white px-4 sm:px-6 py-2 sm:py-3 rounded-md text-sm sm:text-base md:text-lg font-semibold transition-colors duration-300"
                            >
                                {t('contactUs.form.submitButton')}
                            </button>
                        </form>
                    </div>
                </div>
            </div>

            {/* Form Section - Mobile (sm) */}
            <div className="text-center my-6 sm:my-8 block md:hidden">
                <h5 className="text-[#E6A71A] text-sm sm:text-base mb-2 sm:mb-3">
                    {t('contactUs.formSection.subtitle')}
                </h5>
                <h1 className="text-[#114131] text-2xl sm:text-3xl font-bold mb-4 sm:mb-6">
                    {t('contactUs.formSection.title')}
                </h1>
                <div className="w-full max-w-[90%] mx-auto">
                    <form onSubmit={handleSubmit} className="p-3 sm:p-4">
                        <div className="mb-3 sm:mb-4">
                            <input
                                type="text"
                                className="w-full p-2 sm:p-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#114131]"
                                name="name"
                                placeholder={t('contactUs.form.namePlaceholder')}
                                value={formData.name}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="mb-3 sm:mb-4">
                            <input
                                type="tel"
                                className="w-full p-2 sm:p-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#114131]"
                                name="phone"
                                placeholder={t('contactUs.form.phonePlaceholder')}
                                value={formData.phone}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="mb-3 sm:mb-4">
                            <input
                                type="email"
                                className="w-full p-2 sm:p-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#114131]"
                                name="email"
                                placeholder={t('contactUs.form.emailPlaceholder')}
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="mb-3 sm:mb-4">
                            <input
                                type="text"
                                className="w-full p-2 sm:p-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#114131]"
                                name="subject"
                                placeholder={t('contactUs.form.subjectPlaceholder')}
                                value={formData.subject}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="mb-3 sm:mb-4">
                            <textarea
                                className="w-full p-2 sm:p-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#114131]"
                                name="message"
                                placeholder={t('contactUs.form.messagePlaceholder')}
                                value={formData.message}
                                onChange={handleChange}
                                rows="4"
                                required
                            ></textarea>
                        </div>
                        <div className="mb-3 sm:mb-4 flex items-center justify-center">
                            <input
                                type="checkbox"
                                className="h-4 w-4 sm:h-5 sm:w-5 text-[#114131] border-gray-300 rounded focus:ring-[#114131]"
                                id="terms"
                                required
                            />
                            <label
                                className="ml-2 text-gray-600 text-sm sm:text-base"
                                htmlFor="terms"
                            >
                                {t('contactUs.form.termsLabel')}
                            </label>
                        </div>
                        <button
                            type="submit"
                            className="w-full bg-[#114131] hover:bg-[#E6A71A] text-white px-4 sm:px-5 py-2 rounded-md text-sm sm:text-base font-semibold transition-colors duration-300"
                        >
                            {t('contactUs.form.submitButton')}
                        </button>
                    </form>
                </div>
            </div>

            {/* Corporate Section - Desktop (md and larger) */}
            <div className="text-center my-6 sm:my-8 md:my-10 hidden md:block">
                <h5 className="text-[#E6A71A] text-base sm:text-lg md:text-xl mb-2 sm:mb-3">
                    {t('contactUs.corporateSection.subtitle')}
                </h5>
                <h3 className="text-[#114131] text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4 sm:mb-6">
                    {t('contactUs.corporateSection.title')}
                </h3>
                <p className="text-gray-600 text-base sm:text-lg md:text-xl mb-4 sm:mb-6">
                    {t('contactUs.corporateSection.address')}
                </p>
                <div className="flex justify-center gap-3 sm:gap-4 bg-gray-100 p-4 sm:p-5 rounded-md shadow-md">
                    <p className="text-gray-600 text-base sm:text-lg md:text-xl m-0">
                        {t('contactUs.corporateSection.telLabel')}: <a href="tel:+94775340670" className="no-underline text-gray-600 hover:text-[#E6A71A]">+94 77 534 0670</a>
                    </p>
                    <span className="text-gray-600 text-base sm:text-lg md:text-xl">|</span>
                    <p className="text-gray-600 text-base sm:text-lg md:text-xl m-0">
                        {t('contactUs.corporateSection.telLabel')}: <a href="tel:+94779945140" className="no-underline text-gray-600 hover:text-[#E6A71A]">+94 77 994 5140</a>
                    </p>
                    <span className="text-gray-600 text-base sm:text-lg md:text-xl">|</span>
                    <p className="text-gray-600 text-base sm:text-lg md:text-xl m-0">
                        {t('contactUs.corporateSection.emailLabel')}: <a href="mailto:sunflower.beruwala@gmail.com" className="underline text-[#E6A71A] hover:text-[#d9990f]">sunflower.beruwala@gmail.com</a>
                    </p>
                </div>
            </div>

            {/* Corporate Section - Mobile (sm) */}
            <div className="text-center my-6 sm:my-8 block md:hidden">
                <h5 className="text-[#E6A71A] text-sm sm:text-base mb-2 sm:mb-3">
                    {t('contactUs.corporateSection.subtitle')}
                </h5>
                <h3 className="text-[#114131] text-2xl sm:text-3xl font-bold mb-4 sm:mb-6">
                    {t('contactUs.corporateSection.title')}
                </h3>
                <p className="text-gray-600 text-sm sm:text-base mb-4 sm:mb-6 max-w-[90%] mx-auto">
                    {t('contactUs.corporateSection.address')}
                </p>
                <div className="flex flex-col gap-3 sm:gap-4 bg-gray-100 p-3 sm:p-4 rounded-md shadow-md">
                    <p className="text-gray-600 text-sm sm:text-base m-0">
                        {t('contactUs.corporateSection.telLabel')}: <a href="tel:+94775340670" className="no-underline text-gray-600 hover:text-[#E6A71A]">+94 77 534 0670</a>
                    </p>
                    <p className="text-gray-600 text-sm sm:text-base m-0">
                        {t('contactUs.corporateSection.telLabel')}: <a href="tel:+94779945140" className="no-underline text-gray-600 hover:text-[#E6A71A]">+94 77 994 5140</a>
                    </p>
                    <p className="text-gray-600 text-sm sm:text-base m-0">
                        {t('contactUs.corporateSection.emailLabel')}: <a href="mailto:sunflower.beruwala@gmail.com" className="underline text-[#E6A71A] hover:text-[#d9990f]">sunflower.beruwala@gmail.com</a>
                    </p>
                </div>
            </div>

            {/* Location Section - Desktop (md and larger) */}
            <div className="text-center my-6 sm:my-8 md:my-12 hidden md:block">
                <h2 className="text-[#114131] text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4 sm:mb-6">
                    {t('contactUs.locationSection.title')}
                </h2>
                <div className="flex justify-center items-center mt-4 sm:mt-6">
                    <iframe
                        title={t('contactUs.locationSection.mapTitle')}
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5120.9081044221!2d79.9822866!3d6.448697799999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae22ffcb68786a1%3A0xdc99eb138076df4e!2sSun%20flower%20Beach%20Resort!5e1!3m2!1sen!2slk!4v1754564275713!5m2!1sen!2slk"
                        width="100%"
                        height="600"
                        className="rounded-md border-0"
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    />
                </div>
            </div>

            {/* Location Section - Mobile (sm) */}
            <div className="text-center my-6 sm:my-8 block md:hidden">
                <h2 className="text-[#114131] text-2xl sm:text-3xl font-bold mb-4 sm:mb-6">
                    {t('contactUs.locationSection.title')}
                </h2>
                <div className="flex justify-center items-center mt-3 sm:mt-4">
                    <iframe
                        title={t('contactUs.locationSection.mapTitle')}
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5120.9081044221!2d79.9822866!3d6.448697799999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae22ffcb68786a1%3A0xdc99eb138076df4e!2sSun%20flower%20Beach%20Resort!5e1!3m2!1sen!2slk!4v1754564275713!5m2!1sen!2slk"
                        width="100%"
                        height="400"
                        className="rounded-md border-0 w-full"
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    />
                </div>
            </div>
        </div>
    );
}

export default ContactUs;